import { apiUrls } from "../consts/ApiUrls";
import { portalApiClient } from "./apiClient";

export async function updateProjectVariation(payload) {
  const savedData = await portalApiClient.put(
    apiUrls.updateProjectVariation.url(),
    payload
  );
  return savedData.data;
}
